import { useEffect, useState } from 'react';

type MediaQuery = {
  query: string;
};

export function useMediaQuery({ query }: MediaQuery) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handler = (e: { matches: boolean | ((prevState: boolean) => boolean) }) =>
      setMatches(e.matches);

    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
